import React from "react";
import SearchForm from "@containers/Support/SearchForm";
import Sidebar from "@containers/Support/Sidebar";

const SupportLayout = (props) => (
  <>
    <div className="flow-root">
      <SearchForm hasTitle={props.hasTitle} />

      <div className="lg:flex">
        {/* is-hidden-in-mobile-app class is used to hide this content in the WebView used for support and contact sections in mobile app */}
        <div className="lg:w-1/4 is-hidden-in-mobile-app">
          <div className="lg:mx-0 pt-4 lg:pt-12 lg:py-6" id="navigatie-suport">
            <Sidebar items={props.categories} back={props.back} />
          </div>
        </div>

        <div className="lg:w-3/4 lg:pl-12">{props.children}</div>
      </div>
    </div>
  </>
);

export default SupportLayout;
